import logo from "./logo.svg";
import "./App.css";
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
} from "react-router-dom";
import Home from "./Pages/Home";
// import FAQ from "./Pages/FAQ";
// import ProjectsP from "./Pages/ProjectsP";
// import AboutUs from "./Pages/AboutUs";
// import ContactUs from "./Pages/ContactUS";
// import Gallery from "./Pages/Gallery";
// import Donate from "./Pages/Donate";
// import Team from "./Pages/Team";
import { lazy, Suspense } from "react";
import Loading from "./Components/Loading.jsx";

// const Home = lazy(() => import("./Pages/Home"));
const FAQ = lazy(() => import("./Pages/FAQ"));
const AboutUs = lazy(() => import("./Pages/AboutUs"));
const ProjectsP = lazy(() => import("./Pages/ProjectsP"));
const ContactUs = lazy(() => import("./Pages/ContactUS"));
const Gallery = lazy(() => import("./Pages/Gallery"));
const Donate = lazy(() => import("./Pages/Donate"));
const Team = lazy(() => import("./Pages/Team"));
const ReadPost = lazy(() => import("./Pages/ReadPost"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/projects",
    element: <ProjectsP />,
  },
  {
    path: "/about-us",
    element: <AboutUs />,
  },
  {
    path: "/donate",
    element: <Donate />,
  },
  {
    path: "/gallery",
    element: <Gallery />,
  },
  {
    path: "/contact-us",
    element: <ContactUs />,
  },
  {
    path: "/team",
    element: <Team />,
  },
  {
    path: "/read-post",
    element: <ReadPost />,
  },
]);

function App() {
  return (
    <div className='app bg-white'>
      <Suspense fallback={<Loading />}>
        <RouterProvider router={router} />
      </Suspense>
    </div>
  );
}

export default App;
